import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class SidebarServiceService {

  etat : BehaviorSubject<boolean> = new BehaviorSubject(true)

  constructor(private http : HttpClient) {

  }

  getSearchList() {
    return this.http.get<any[]>("assets/search-flie.json");
  }
}
